import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'infra-load_animation_frames-view';
/**
 * Tracks the length of animation frames during page load.
 */
export function trackInfraLoadAnimationFramesView(FrameTimings, TotalWindowLength2, Status3 = '', Name4 = '', LoadType5 = '', Status6 = '') {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: {
            FrameTimings,
            TotalWindowLength2,
            Status3,
            Name4,
            LoadType5,
            Status6,
        },
    });
}
